import React, { Component, Fragment } from 'react';
import { CustomLoading, Loading } from './LoadingComponent';
import { connect } from 'react-redux';
import { Breadcrumb, BreadcrumbItem, Button, Alert,
         Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { CSVLink } from "react-csv";
import { aggregate, latest_by_key, CustomListSelect } from './Functions';
import { RenderVirtualTable } from './TableComponent';
import { postRequest } from '../redux/ActionCreators';

// import { Auth } from 'aws-amplify';
const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    tactical_params: state.tactical_params,
    port_metrics_tactical: state.port_metrics_tactical,
  };
};

class PortTactical extends Component {
  constructor(props){
      super(props);
      this.state = {
        loading_funds:false,
        saving_funds:false,
        assign_fund:false,
        msg:null,
        msg_save:null,
        asset_sel:null,
        fund_sel:null
      };
      this.header = this.header.bind(this);
      this.openAssignModal = this.openAssignModal.bind(this);
      this.saveFund = this.saveFund.bind(this);
      this.queryFunds = this.queryFunds.bind(this);
  }
    
    async queryFunds(){
      console.log("query funds.")
      this.setState({loading_funds:true});
      // Query database
      let funds_df;
      let funds_asset_data;
      try {
        funds_df = await postRequest({
          database:'wmdb',
          query_string:`SELECT * FROM InvestTickers WHERE PortId='${this.props.tactical_params.port_name}'`,
        }, 'query_database').then(query=>{
            if (!query?.data) return [];  // <--- safe guard
            return latest_by_key(query.data, "Asset", "DateTicker");
        });
      } catch(error) {
        console.log(error.message);
        await this.props.changeModel("tactical_params.funds", null);
        this.setState({
          msg:error.message,
          loading_funds:false
        });
        return;
      }
      // Query assetData
      try {
        funds_asset_data = await postRequest({
          bucket:'condor-sura', 
          key:'output/asset_data/asset_data_consol.csv', 
          sep:',',
          query_string:`
            SELECT Asset,TickerBenchmark,TickerInvestAsset
            FROM s3Object s
            WHERE s."Asset" in ('${this.props.tactical_params.port.map(item => item.Asset.replace(/'/g, "\\'")).join("', '")}')
          `,
        }, 'retrieve_data_s3');
      } catch (error) {
        await this.props.changeModel("tactical_params.funds", null);
        this.setState({
          msg: error.message,
          loading_funds:false
        });
        return;
      }
      // Join data
      await this.props.changeModel("tactical_params.funds", 
        [
          ...funds_df.map(item=>{
            return {Activo:item.Asset, Ticker:funds_asset_data.find(k=>k.Asset==item.Asset)?.TickerBenchmark, Fecha:item.DateTicker, "Seleccionado/Default":item.Ticker};
          }), 
          ...funds_asset_data.map(item=>{
            return {Activo:item.Asset, Ticker:item.TickerBenchmark, Fecha:"", "Seleccionado/Default":item.TickerInvestAsset};
          })
        ]
      );
      this.setState({loading_funds:false});

      
    }

    openAssignModal(){
      if (this.props.tactical_params.funds==null) {
        this.setState({msg:'No se ha cargado ningún portafolio'});
      } else {
        this.setState({assign_fund:true});
      }
    }
    
  
    async saveFund(){
      if (this.state.asset_sel==null) {
        this.setState({msg_save:'Seleccionar activo'});
      }else if (this.state.fund_sel==null) {
        this.setState({msg_save:'Seleccionar fondo/ETF'});
      } else {
        this.setState({saving_funds:true});
        try {
          const res = await postRequest({
            database:'wmdb',
            query_string:`INSERT INTO InvestTickers (PortId, Asset, Ticker, DateTicker) values ('${this.props.tactical_params.port_name}', '${this.state.asset_sel}', '${this.state.fund_sel.value}', '${(new Date()).toISOString().slice(0,10)}')`,
          }, 'query_database');
          this.setState({
            saving_funds:false,
            msg_save:res.msg
          });
          if (res.status=="ok"){
            await this.queryFunds()
          }
        } catch (error) {
          this.setState({
            saving_funds:false,
            msg_save: error.message
          });
        }
      }
    }
    
    header(){
      return (
        <>
          <div className="row mt-5 justify-content-center">
            <div className="col-md-8">
              <h4>Análisis Táctico</h4>
            </div>  
          </div>
          <div className="row mt-2 justify-content-center">
            <div className="col-auto">
              <Breadcrumb>
                <BreadcrumbItem><Link to='/portfolio/tactical'>Allocation</Link></BreadcrumbItem>
                <BreadcrumbItem active>Selección de Fondos</BreadcrumbItem>
              </Breadcrumb>
            </div>
          </div>
        </>
        );
    }

  render() {
      if(this.props.user_wm.isLogging){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Loading />
            </div>
          </div>
        );
      } else if (this.props.tactical_params.port_name==null || this.props.tactical_params.port==null){
        return(
          <div className="container">
            {this.header()}
            <div className="row m-4 justify-content-center">
              <div className='col-8'>
                <h6>Seleccionar y cargar portafolio Portafolio</h6>
              </div>
            </div>
          </div>
        );
      } else {
        const fund_options = this.props.user_wm.data.assets.filter(x=>x.AssetType=="Fund/ETF").map(x=>{
          return({value:x.Ticker, label:`${x.Asset} | ${x.Isin}`});
        });
        return (
          <div className="container">
            {this.header()}
            <div className="row m-4 justify-content-center">
              <div className='col-8'>
                <h5>{this.props.tactical_params.port_name}</h5>
              </div>
            </div>
            <div className="row m-4 justify-content-center">
              {this.state.loading_funds ?
                <div className="col-auto m-1">
                  <CustomLoading msg="cargando fondos" icon="fa-database" />
                </div>
              : <div className="col-auto m-1">
                  <Button 
                    onClick={this.queryFunds}
                    className="btn-corp">
                      Ver fondos
                  </Button>
                </div>
              }
              {this.props.tactical_params.funds ?
                <div className="col-auto m-1">
                  <Button 
                    onClick={this.openAssignModal}
                    className="btn-corp">
                      Asignar Nuevo Fondo
                  </Button>
                </div>
              : null
              }
            </div>
            
            
            {this.props.tactical_params.funds!==null ?
              <>
                <div className="row mt-5 justify-content-center">
                  <div className='col-auto'>
                    <h5>Fondos Seleccionados</h5>
                  </div>
                </div>
                <div className="row mt-3 justify-content-center">
                  <div className='col-auto'>
                    <RenderVirtualTable 
                      data={this.props.tactical_params.funds} 
                      to_perc={[false, true]}
                      cell_width={["250px", '150px', '150px']}
                      item_size={30}
                      />
                  </div>
                </div>
              </>
            : null
            }
            <Modal isOpen={this.state.assign_fund} toggle={()=>this.setState({assign_fund:!this.state.assign_fund})} size="lg">
              <ModalHeader toggle={()=>this.setState({assign_fund:!this.state.assign_fund})}>Seleccionar Fondo</ModalHeader>
              <ModalBody>
                <div className="row justify-content-center">
                  <div className='col-5'>
                    <CustomListSelect
                      maxMenuHeight={100}
                      options={this.props.tactical_params.port.map(item=>{
                        return {value:item.Asset, label:item.Asset};
                      })}
                      isClearable={true}
                      value={this.state.asset_sel==null ? null : {value:this.state.asset_sel, label:this.state.asset_sel}}
                      onChange={(e)=>this.setState({asset_sel:e?.value})}
                      itemSize={50}
                      className="basic-single"
                      placeholder="seleccionar activo"
                      fontsize={10}
                    />
                  </div>
                  <div className='col-5'>
                    <CustomListSelect
                      maxMenuHeight={100}
                      options={fund_options}
                      isClearable={true}
                      value={this.state.fund_sel==null ? null : this.state.fund_sel}
                      onChange={(e)=>this.setState({fund_sel:e})}
                      itemSize={50}
                      className="basic-single"
                      placeholder="seleccionar activo"
                      fontsize={10}
                    />
                  </div>
                </div>
                <div className="row mt-4 justify-content-center">
                  {this.state.saving_funds ?
                    <div className='col-auto'>
                      <CustomLoading msg="asignando fondo" icon="fa-database"/>
                    </div>
                  : 
                  <>
                    <div className="col-auto">
                      <Button 
                        onClick={this.saveFund}
                        className="btn-corp">
                          Asignar
                      </Button>
                    </div>
                    <div className="col-auto">
                      <Button 
                        onClick={()=>{
                         this.setState({
                          assign_fund:false,
                          msg_save:false 
                         });
                        }}
                        className="btn-corp">
                          Cancelar
                      </Button>
                    </div>
                  </>
                  }
                </div>
                <div className="row mt-2 justify-content-center">
                  <div className="col-8">
                    <Alert
                      color='secondary'
                      isOpen={this.state.msg_save!=='' && this.state.msg_save!==null} 
                      toggle={()=>this.setState({msg_save:null})}
                      fade={false}
                      >
                        {this.state.msg_save}
                    </Alert>
                  </div>
                </div>
              </ModalBody>  
            </Modal>
            <div className="row mt-4 justify-content-center">
              <div className="col-4 m-3">
                <Alert
                  color='secondary'
                  isOpen={this.state.msg!=='' && this.state.msg!==null} 
                  toggle={()=>this.setState({msg:null})}
                  fade={false}
                  >
                    {this.state.msg}
                </Alert>
              </div>
            </div>
          </div>
        );
      }
    }
}
//export default Port;
export default withRouter(connect(mapStateToProps)(PortTactical));